// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-cell-focus,
.ag-cell {
  border: none !important;
  display: flex;
  height: 100%;
  align-items: center;
}

.ag-header-cell {
  background-color: white;
  color: rgb(131, 146, 171);
  font-size: 0.75rem;
  font-weight: 700;
}

.ag-header {
  border: none !important;
}
.ag-aria-description-container {
  display: none;
}
.ag-root-wrapper {
  border: none !important;
}

.ag-body-vertical-scroll {
  display: none;
  width: 0;
}
@media only screen and (min-width: 767px) {
  .ag-center-cols-viewport {
    overflow-x: hidden !important;
  }
}

.ag-cell.ag-cell-checkbox-input-wrapper {
  cursor: pointer;
}

.ag-header-cell-label {
  justify-content: center;
}

.ag-ltr .ag-cell {
  border-right-width: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.statusConteiner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.feedbackReceivedByCETrue {
  display: block;
  height: 20px;
  width: 20px;
  border-radius: 100px;
  background-color: greenyellow;
  /* box-shadow: 0 0 5px red; */
}

.feedbackReceivedByCEFalse {
  display: block;
  height: 20px;
  width: 20px;
  border-radius: 100px;
  background-color: red;
  /* box-shadow: 0 0 5px greenyellow; */
}
`, "",{"version":3,"sources":["webpack://./src/examples/QueuedTable/index.css"],"names":[],"mappings":"AAAA;;EAEE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,qCAAqC;AACvC","sourcesContent":[".ag-cell-focus,\r\n.ag-cell {\r\n  border: none !important;\r\n  display: flex;\r\n  height: 100%;\r\n  align-items: center;\r\n}\r\n\r\n.ag-header-cell {\r\n  background-color: white;\r\n  color: rgb(131, 146, 171);\r\n  font-size: 0.75rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.ag-header {\r\n  border: none !important;\r\n}\r\n.ag-aria-description-container {\r\n  display: none;\r\n}\r\n.ag-root-wrapper {\r\n  border: none !important;\r\n}\r\n\r\n.ag-body-vertical-scroll {\r\n  display: none;\r\n  width: 0;\r\n}\r\n@media only screen and (min-width: 767px) {\r\n  .ag-center-cols-viewport {\r\n    overflow-x: hidden !important;\r\n  }\r\n}\r\n\r\n.ag-cell.ag-cell-checkbox-input-wrapper {\r\n  cursor: pointer;\r\n}\r\n\r\n.ag-header-cell-label {\r\n  justify-content: center;\r\n}\r\n\r\n.ag-ltr .ag-cell {\r\n  border-right-width: 1px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.statusConteiner {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n.feedbackReceivedByCETrue {\r\n  display: block;\r\n  height: 20px;\r\n  width: 20px;\r\n  border-radius: 100px;\r\n  background-color: greenyellow;\r\n  /* box-shadow: 0 0 5px red; */\r\n}\r\n\r\n.feedbackReceivedByCEFalse {\r\n  display: block;\r\n  height: 20px;\r\n  width: 20px;\r\n  border-radius: 100px;\r\n  background-color: red;\r\n  /* box-shadow: 0 0 5px greenyellow; */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
